// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import { getColor } from '../../../../styled/color';
import CrossIcon from '../../../../assets/images/cross-icon.svg';

const S = {
  SnackbarBubble: styled.div`
    margin-top: 20px;
    padding: 20px;
    display: flex;
    align-items: center;
    background: #434343;
    border-radius: 4px;
    min-width: 430px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  `,
  SnackbarIcon: styled.div`
    margin-right: 17px;
    width: 13px;
    height: 13px;
  `,
  SnackbarMessage: styled.div`
    font: 16px Noto Sans TC;
    letter-spacing: 0.29px;
    color: ${getColor('White')};
    max-width: 257px;
    overflow-wrap: break-word;
  `,
  SnackbarControlContainer: styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
  `,
  SnackbarDecline: styled.img.attrs({ src: CrossIcon, alt: 'cross-icon'})`
    margin-left: 32px;
    cursor: pointer;
  `
};

export const SnackbarAccept = styled.div`
  font: 16px Noto Sans TC;
  letter-spacing: 0.29px;
  color: #FCA032;
  cursor: pointer;
`;

export default S;
